import { Carousel, Col, Row } from "react-bootstrap";
import "../../Css/Menu.css";

import { Link, useHistory } from "react-router-dom";
import ModalSendSMS from "../Modals/ModalSendSMS";
import ModalReminder from "../Modals/ModalReminder";
import ModalSearchReminders from "../../Pages/ModalSearchReminders";
import ModalNewNotice from "../Modals/ModalNewNotice";
import { Fragment, useState } from "react";
import { invoiceTypes, checkModule, systemModules, networkRelease, setErrorDialog } from "../../store/api/CommonFunctions";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Power, House, Tools, FileEarmarkPost, Search, UiChecksGrid, GridFill, Grid1x2Fill, Book, BookHalf, BookFill, Grid3x3GapFill, JournalText,
  FileEarmarkText, FileEarmarkRuledFill, FileEarmarkTextFill, FileEarmarkRuled, FilePostFill, FileSpreadsheet, FilePost, FileSpreadsheetFill,
  Stickies, LayoutTextWindow, Files, UpcScan, Command, ChatRight, PersonBadge, PersonPlus, ChatRightText, CalendarEventFill, Table, Check2Square,
  HddNetwork
} from "react-bootstrap-icons";
import ModalActiveGuaranteeCard from "../../Services/Components/ModalActiveGuaranteeCard";
const company = JSON.parse(localStorage.getItem("Company"));
const roleList = JSON.parse(localStorage.getItem("RoleList"));
const Menu = (props) => {
  const history = useHistory();
  const { menuName } = props;
  const dispatch = useDispatch();
  const [modalSMS, setModalSMS] = useState({ show: false });
  const [popReminder, setPopReminder] = useState({ show: false });
  const [showSearchReminderModal, setShowSearchReminderModal] = useState(false);
  const [modalNoticeData, setModalNoticeData] = useState({ show: false });
  const [modalActiveCard, setModalActiveCard] = useState({ show: false });
  const { activeSS, appModules } = useSelector(state => { return { activeSS: state.SystemSettingsReducer.activeSubsystems?.Data, appModules: state.SystemSettingsReducer.appModules?.Data } });
  const logOut = () => {
    localStorage.removeItem("token");
  }
  const closeMenu = () => {
    document.querySelector("input[type='checkbox']:checked").checked = false;
  }
  function showModalSMS() {
    setModalSMS({
      show: true
    })
    closeMenu();

  }
  function showModalNotice() {
    setModalNoticeData({
      show: true
    })
    closeMenu();
  }
  const showReminderModal = () => {
    setPopReminder({ show: true });
    closeMenu();
  }
  function releaseNet() {
    const onSucess = (res) => {
      if (res.Error) {
        setErrorDialog(dispatch, res.Error, "آزادسازی شبکه");
      }
      else if (res?.toLowerCase() === "success") {
        setErrorDialog(dispatch, "success", "آزادسازی شبکه");
        window.location.reload();
      }
    }
    networkRelease(onSucess);
  }
  const subSystemHome = useCallback((name) => {
    switch (name) {
      case "Service":
        return "/Services";
      case "Sale":
        return "/Sale";
      case "Accounting":
        return "/Accounting";
      case "CRM":
        return "/CRM";
      default:
        return "/";
    }
  });
  function goSystemHome() {
    closeMenu();
    const to = "/" + menuName.replace("Service", "Services");
    history.push(to);

  }
  const handleSelect = (selectedIndex, e) => {
    //setIndex(selectedIndex);

  };
  function showUSerDashBoard() {
    closeMenu();
    history.push("/UserDashboard");
  }
  function checkSS(name) {
    return activeSS !== undefined && Array.isArray(activeSS) && activeSS.some(s => s === name);
  }
  function showModalActiveCard() {
    setModalActiveCard({ show: true });
    closeMenu();
  }
  useState(() => {

  }, [menuName])
  return (
    <label className="menuContainer" style={{ color: "black" }}>
      <ModalSendSMS popData={modalSMS} setPopData={setModalSMS} />
      <ModalReminder pop={popReminder} setPop={setPopReminder} />
      <ModalSearchReminders showModal={showSearchReminderModal} setShow={setShowSearchReminderModal} setPopReminder={setPopReminder} />
      <ModalNewNotice popData={modalNoticeData} setPopData={setModalNoticeData} />
      <ModalActiveGuaranteeCard popData={modalActiveCard} setPopData={setModalActiveCard} />
      <input type='checkbox' />
      <span className='menu'> <span className='hamburger'></span><span></span><a href="/" onClick={logOut} style={{ fontStyle: "bold", color: "red" }}><Power size={30} /></a></span>
      <div className="menuList">
        <img src="/logo192.png" alt="image" style={{ marginLeft: '10%' }} />
        <Carousel interval={null} prevIcon={null} nextIcon={null} className="mt-2">
          {(menuName === "Main" || menuName === "Accounting") && checkSS("Finances") && checkModule(appModules, systemModules.Finances) &&
            <Carousel.Item style={{ height: "500px" }}>
              <Carousel.Caption>
                <Link to={subSystemHome(menuName)} onClick={closeMenu}>
                  <h5 style={{ color: "black" }}>امور مالی</h5>
                </Link>
              </Carousel.Caption>
              <Row style={{ marginLeft: "5px", marginRight: "5px" }}>
                <Col>
                  <Link to="/Accounting/AddEditDocument/0" onClick={closeMenu}>
                    <FileEarmarkPost style={{ marginTop: "6px", color: '#9f247e' }} size={22} />
                    <p style={{ marginTop: "6px", color: "black" }}>ثبت سند</p>
                  </Link>
                </Col>
                <Col>
                </Col>
                <Col>
                  <Link to="/Accounting/SearchDocuments" onClick={closeMenu}>
                    <Search style={{ marginTop: "6px", color: 'rgb(167 37 33)' }} size={22} />
                    <p style={{ marginTop: "6px", color: "black" }}>جستجوی سند</p>
                  </Link>
                </Col>
              </Row>
              <Row style={{ marginLeft: "5px", marginRight: "5px" }}>
                <Col>
                  <Link to="/Accounting/CreditorDebtorList" onClick={closeMenu}>
                    <JournalText style={{ marginTop: "6px", color: '#0f6d6f' }} size={22} />
                    <p style={{ marginTop: "6px", color: "black" }}>بدهکاران/بستانکاران</p>
                  </Link>
                </Col>
                <Col>
                  <Link to="/Accounting/AccountingBalance/0/0" onClick={closeMenu}>
                    <Grid1x2Fill style={{ marginTop: "6px", color: '#4e1886' }} size={22} />
                    <p style={{ marginTop: "6px", color: "black" }}>تراز گروه</p>
                  </Link>
                </Col>
                <Col>
                  <Link to="/Accounting/AccountingBalance/1/0" onClick={closeMenu}>
                    <GridFill style={{ marginTop: "6px", color: 'rgb(167 37 33)' }} size={22} />
                    <p style={{ marginTop: "6px", color: "black" }}>تراز کل</p>
                  </Link>
                </Col>
              </Row>
              <Row style={{ marginLeft: "5px", marginRight: "5px" }}>
                <Col>
                  <Link to="/Accounting/AccountingBalance/2/0" onClick={closeMenu}>
                    <UiChecksGrid style={{ marginTop: "6px", color: 'blue' }} size={22} />
                    <p style={{ marginTop: "6px", color: "black" }}>تراز معین</p>
                  </Link>
                </Col>
                <Col>
                  <Link to="/Accounting/AccountingBalance/3/0" onClick={closeMenu}>
                    <Grid3x3GapFill style={{ marginTop: "6px", color: '#bb1370' }} size={22} />
                    <p style={{ marginTop: "6px", color: "black" }}>تراز تفصیلی</p>
                  </Link>
                </Col>
                <Col>
                  <Link to="/Accounting/AccountingBook/0/0/0" onClick={closeMenu}>
                    <Book style={{ marginTop: "6px", color: '#4e1886' }} size={22} />
                    <p style={{ marginTop: "6px", color: "black" }}>دفتر حساب گروه</p>
                  </Link>
                </Col>
              </Row>
              <Row style={{ marginLeft: "5px", marginRight: "5px", marginBottom: "75px" }}>
                <Col>
                  <Link to="/Accounting/AccountingBook/1/0/0" onClick={closeMenu}>
                    <Book style={{ marginTop: "6px", color: 'rgb(167 37 33)' }} size={22} />
                    <p style={{ marginTop: "6px", color: "black" }}>دفتر حساب کل</p>
                  </Link>
                </Col>
                <Col>
                  <Link to="/Accounting/AccountingBook/2/0/0" onClick={closeMenu}>
                    <BookHalf style={{ marginTop: "6px", color: 'blue' }} size={22} />
                    <p style={{ marginTop: "6px", color: "black" }}>دفتر حساب معین</p>
                  </Link>
                </Col>
                <Col>
                  <Link to="/Accounting/AccountingBook/3/0/0" onClick={closeMenu}>
                    <BookFill style={{ marginTop: "6px", color: '#bb1370' }} size={22} />
                    <p style={{ marginTop: "6px", color: "black" }}>دفتر حساب تفصیلی</p>
                  </Link>
                </Col>
              </Row>

            </Carousel.Item>
          }
          {(menuName === "Main" || menuName === "Sale") && checkSS("SaleAndStorage") && (checkModule(appModules, systemModules.StorageInvoice) || checkModule(appModules, systemModules.Sale)) &&
            <Carousel.Item style={{ height: "500px" }}>
              <Carousel.Caption>
                <Link to={subSystemHome(menuName)} onClick={closeMenu}>
                  <h5>فروش و انبار</h5>
                </Link>
              </Carousel.Caption>
              {checkModule(appModules, systemModules.StorageInvoice) &&
                <Fragment>
                  <Row style={{ marginLeft: "5px", marginRight: "5px" }}>
                    <Col>
                      <Link to={`/Sale/Invoice/${invoiceTypes.PreSale}/0/false`} onClick={closeMenu}>
                        <FileEarmarkRuled style={{ marginTop: "2px", color: '#4e1886' }} size={22} />
                        <p style={{ marginTop: "6px", color: "black" }}>پیش فاکتور فروش</p>
                      </Link>
                    </Col>
                    <Col>
                      <Link to={`/Sale/Invoice/${invoiceTypes.Sale}/0/false`} onClick={closeMenu}>
                        <FileEarmarkRuledFill style={{ marginTop: "6px", color: '#4e1886' }} size={22} />
                        <p style={{ marginTop: "6px", color: "black" }}>فاکتور فروش</p>
                      </Link>
                    </Col>
                    <Col>
                      <Link to={`/Sale/Invoice/${invoiceTypes.ReturnFromSale}/0/false`} onClick={closeMenu}>
                        <FileEarmarkRuledFill style={{ marginTop: "6px", color: 'red' }} size={22} />
                        <p style={{ marginTop: "6px", color: "black" }}>برگشت فروش</p>
                      </Link>
                    </Col>
                  </Row>

                  <Row style={{ marginLeft: "5px", marginRight: "5px" }}>
                    <Col>
                      <Link to={`/Sale/Invoice/${invoiceTypes.PrePurchase}/0/false`} onClick={closeMenu}>
                        <FileEarmarkText style={{ marginTop: "6px" }} size={22} />
                        <p style={{ marginTop: "6px", color: "black" }}>پیش فاکتور خرید</p>
                      </Link>
                    </Col>
                    <Col>
                      <Link to={`/Sale/Invoice/${invoiceTypes.Purchase}/0/false`} onClick={closeMenu}>
                        <FileEarmarkTextFill style={{ marginTop: "6px" }} size={22} />
                        <p style={{ marginTop: "6px", color: "black" }}>فاکتور خرید</p>
                      </Link>
                    </Col>
                    <Col>
                      <Link to={`/Sale/Invoice/${invoiceTypes.Purchase}/0/false`} onClick={closeMenu}>
                        <FileEarmarkTextFill style={{ marginTop: "6px" }} size={22} color="red" />
                        <p style={{ marginTop: "6px", color: "black" }}>برگشت از خرید</p>
                      </Link>
                    </Col>
                  </Row>
                  <Row style={{ marginLeft: "5px", marginRight: "5px" }}>
                    <Col>
                      <Link to={`/Sale/Invoice/${invoiceTypes.Havaleh}/0/false`} onClick={closeMenu}>
                        <FileEarmarkRuledFill style={{ marginTop: "6px", color: '#4e1886' }} size={22} />
                        <p style={{ marginTop: "6px", color: "black" }}>حواله انبار</p>
                      </Link>
                    </Col>
                    <Col>
                      <Link to={`/Sale/Invoice/${invoiceTypes.Resid}/0/false`} onClick={closeMenu}>
                        <FileEarmarkPost style={{ marginTop: "6px", color: 'rgb(55 124 142)' }} size={22} />
                        <p style={{ marginTop: "6px", color: "black" }}>رسید انبار</p>
                      </Link>
                    </Col>
                    <Col>
                      <Link to={`/Sale/Invoice/${invoiceTypes.Borrow}/0/false`} onClick={closeMenu}>
                        <FileEarmarkRuled style={{ marginTop: "6px", color: '#aa1550' }} size={22} />
                        <p style={{ marginTop: "6px", color: "black" }}>حواله به نماینده</p>
                      </Link>
                    </Col>
                  </Row>
                </Fragment>
              }
              <Row style={{ marginLeft: "5px", marginRight: "5px" }}>
                <Col>
                  <Link to={`/Sale/Invoice/${invoiceTypes.PreSale}/0/true`} onClick={closeMenu}>
                    <FilePostFill style={{ marginTop: "6px", color: '#d509e3' }} size={22} />
                    <p style={{ marginTop: "6px", color: "black" }}>پیش فاکتور فروش رسمی</p>
                  </Link>
                </Col>
                <Col>
                  <Link to={`/Sale/Invoice/${invoiceTypes.Sale}/0/true`} onClick={closeMenu}>
                    <FilePost style={{ marginTop: "6px", color: 'orange' }} size={22} />
                    <p style={{ marginTop: "6px", color: "black" }}>فاکتور فروش رسمی</p>
                  </Link>
                </Col>
                <Col>
                  <Link to={`/Sale/Invoice/${invoiceTypes.ReturnFromSale}/0/true`} onClick={closeMenu}>
                    <FilePost style={{ marginTop: "6px", color: '#ff1000' }} size={22} />
                    <p style={{ marginTop: "6px", color: "black" }}>برگشت از فروش رسمی</p>
                  </Link>
                </Col>
              </Row>
              <Row style={{ marginLeft: "5px", marginRight: "5px", marginBottom: "75px" }}>
                <Col>
                  <Link to={`/Sale/Invoice/${invoiceTypes.PrePurchase}/0/true`} onClick={closeMenu}>
                    <FileSpreadsheet style={{ marginTop: "6px", color: "#080f81" }} size={22} />
                    <p style={{ marginTop: "6px", color: "black" }}>پیش فاکتور خرید رسمی</p>
                  </Link>
                </Col>
                <Col>
                  <Link to={`/Sale/Invoice/${invoiceTypes.Purchase}/0/true`} onClick={closeMenu}>
                    <FileSpreadsheetFill style={{ marginTop: "2px", color: "#080f81" }} size={22} />
                    <p style={{ marginTop: "6px", color: "black" }}>فاکتور  خرید رسمی</p>
                  </Link>
                </Col>
                <Col>
                  <Link to="/Sale/SearchInvoice" onClick={closeMenu}>
                    <div style={{ position: "relative", display: "inline-block" }}>
                      <Search size={18} color="#0f0389" fontWeight="bold" style={{ position: "absolute", marginTop: "12px", scale: "1.1", left: "10px" }} />
                      <FileEarmarkRuled style={{ marginTop: "6px", color: 'rgb(167 37 33)' }} size={22} />
                    </div>
                    <p style={{ marginTop: "6px", color: "black" }}>جستجوی فاکتور</p>
                  </Link>
                </Col>
              </Row>
            </Carousel.Item>
          }
          {(menuName === "Main" || menuName === "Service") && checkSS("AfterSalesService") && checkModule(appModules, systemModules.Services) &&
            <Carousel.Item style={{ height: "500px" }}>
              <Carousel.Caption>
                <Link to={subSystemHome(menuName)} onClick={closeMenu}>
                  <h5>خدمات پس از فروش</h5>
                </Link>
              </Carousel.Caption>
              <Row style={{ marginLeft: "5px", marginRight: "5px" }}>
                <Col>
                  <Link to="/Services/Service/0/0" onClick={closeMenu}>
                    <Tools style={{ marginTop: "6px", color: '#9f247e' }} size={22} />
                    <p style={{ marginTop: "6px", color: "black" }}>ثبت پذیرش</p>
                  </Link>
                </Col>
                <Col>
                  <Link to="/Services/tasks" onClick={closeMenu}>
                    <UiChecksGrid style={{ marginTop: "6px", color: 'red' }} size={22} />
                    <p style={{ marginTop: "6px", color: "black" }}>کارهای من</p>
                  </Link>
                </Col>
                <Col>
                  <Link to="/Services/myTasks" onClick={closeMenu}>
                    <Stickies style={{ color: '#0f75b1', marginTop: "6px" }} size={22} />
                    <p style={{ marginTop: "6px", color: "black" }}>جستجوی کارها</p>
                  </Link>
                </Col>
              </Row>
              <Row style={{ marginLeft: "5px", marginRight: "5px" }}>
                <Col>
                  <Link to="/Services/PartRequest/0" onClick={closeMenu}>
                    <LayoutTextWindow style={{ color: "blue", marginTop: "6px" }} size={22} />
                    <p style={{ marginTop: "6px", color: "black" }}>ثبت درخواست قطعه</p>
                  </Link>
                </Col>
                <Col>
                  <Link to="/Services/SearchProductRequest" onClick={closeMenu}>
                    <Files style={{ color: 'red', marginTop: "6px" }} size={22} />
                    <p style={{ marginTop: "6px", color: "black" }}>جستجوی درخواست قطعه</p>
                  </Link>
                </Col>
                {checkModule(appModules, systemModules.GuaranteeCheck) &&
                  <Col>
                    <Link to="" onClick={showModalActiveCard}>
                      <Check2Square style={{ color: 'green', marginTop: "6px" }} size={22} />
                      <p style={{ marginTop: "6px", color: "black" }}>فعال سازی گارانتی</p>
                    </Link>
                  </Col>
                }
              </Row>
              {checkModule(appModules, systemModules.Commands) &&
                <Row style={{ marginLeft: "5px", marginRight: "5px", marginBottom: "75px" }}>
                  <Col>
                    <Link to="/Services/SearchCommands" onClick={closeMenu}>
                      <Command style={{ color: "seagreen", marginTop: "6px" }} size={22} />
                      <p style={{ marginTop: "6px", color: "black" }}>جستجوی دستور کار</p>
                    </Link>
                  </Col>
                  <Col>
                    <Link to="/Services/Commands/0/0/0" onClick={closeMenu}>
                      <ChatRight style={{ color: 'red', marginTop: "6px" }} size={22} />
                      <p style={{ marginTop: "6px", color: "black" }}>دستور کار</p>
                    </Link>
                  </Col>
                  <Col>
                    <Link to="" onClick={closeMenu}>
                      <p style={{ marginTop: "6px", color: "black" }}></p>
                    </Link>
                  </Col>
                </Row>
              }
            </Carousel.Item>
          }
          {(menuName === "Main" || menuName === "CRM") && checkModule(appModules, systemModules.CRM) &&
            <Carousel.Item style={{ height: "500px" }}>
              <Carousel.Caption>
                <Link to={subSystemHome(menuName)} onClick={closeMenu}>
                  <h5>مشتریان</h5>
                </Link>
              </Carousel.Caption>
              <Row style={{ marginLeft: "5px", marginRight: "5px" }}>
                <Col>
                  <Link to="/CRM/ModalCustomerStatus" onClick={closeMenu}>
                    <PersonBadge style={{ marginTop: "6px", color: '#d83904' }} size={22} />
                    <p style={{ marginTop: "6px", color: "black" }}>وضعیت مشتری</p>
                  </Link>
                </Col>
                <Col>
                  <Link to="/CRM/AddEditCustomer/0" onClick={closeMenu}>
                    <PersonPlus style={{ marginTop: "6px", color: '#0b8e95' }} size={23} />
                    <p style={{ marginTop: "6px", color: "black" }}>ثبت مشتری</p>
                  </Link>
                </Col>
                <Col>
                  <Link to="/CRM/SearchCustomer" onClick={closeMenu}>
                    <Search style={{ marginTop: "6px", color: '#a944a9' }} size={22} />
                    <p style={{ marginTop: "6px", color: "black" }}>جستجوی مشتری</p>
                  </Link>
                </Col>
              </Row>
              <Row style={{ marginLeft: "5px", marginRight: "5px" }}>
                <Col>
                  <Link to="/CRM/ModalPreCustomerStatus" onClick={closeMenu}>
                    <PersonBadge style={{ marginTop: "6px", color: 'green' }} size={22} />
                    <p style={{ marginTop: "6px", color: "black" }}>وضعیت مشتری بالقوه</p>
                  </Link>
                </Col>
                <Col>
                  <Link to="/CRM/AddEditPreCustomer/0" onClick={closeMenu}>
                    <PersonPlus style={{ marginTop: "6px", color: '#0b8e95' }} size={22} />
                    <p style={{ marginTop: "6px", color: "black" }}>ثبت مشتری بالقوه</p>
                  </Link>
                </Col>
                <Col>
                  <Link to="/CRM/SearchPreCustomer" onClick={closeMenu}>
                    <Search style={{ marginTop: "6px", color: '#804600' }} size={22} />
                    <p style={{ marginTop: "6px", color: "black" }}>جستجوی مشتری بالقوه</p>
                  </Link>
                </Col>
              </Row>
              <Row style={{ marginLeft: "5px", marginRight: "5px", marginBottom: "75px" }}>
                <Col>
                  <Link to="/CRM/Ticket" onClick={closeMenu}>
                    <ChatRightText style={{ marginTop: "2px", color: 'blue' }} size={22} />
                    <p style={{ marginTop: "6px", color: "black" }}>تیکت های ثبت شده</p>
                  </Link>
                </Col>
                {checkModule(appModules, systemModules.EventsManagement) &&
                  <Col>
                    <Link to="/CRM/EventsHistory" onClick={closeMenu}>
                      <CalendarEventFill size={22} style={{ marginTop: "2px", color: 'orange' }} />
                      <p style={{ marginTop: "6px", color: "black" }}>تاریخچه رویدادها</p>
                    </Link>
                  </Col>
                }
                <Col>
                  {/* <Link to="/CRM/AddEditSaleCampaign/0" onClick={closeMenu}>
                    <PersonBadge style={{ marginTop: "6px", color: 'blue' }} size={22} />
                    <p style={{ marginTop: "6px", color: "black" }}>تعریف/ویرایش کمپین</p>
                  </Link> */}
                </Col>
              </Row>
            </Carousel.Item>
          }
        </Carousel>
        <div style={{ margin:0 }}>
          <a href="#" style={{ display: "inline-block", padding: "4px" }} title="آزادسازی شبکه"> <HddNetwork size={25} onClick={releaseNet} /></a>
          <Link to="/UserDashboard" onClick={closeMenu} style={{ display: "inline-block", padding: "3px" }} title="کارتابل کاربر"><Table size={25} color="#ff6800" /></Link>
          <a href="/" onClick={closeMenu} style={{ display: "inline-block", padding: "3px" }}><House size={25} color="blue" /></a>
          <a href="/" onClick={logOut} style={{ display: "inline-block", padding: "3px" }}><Power color="red" size={25} /></a>
        </div>
        <ul className="horizontalList mt-3">
          <li><a href={company?.AboutUS}>
            درباره ما</a></li>
          <li ><a href={company?.ContactUS}>تماس با ما</a></li>
          <li><a href={company?.WebSite}>سایت شرکت</a></li>
          <li><a href={company?.NewsURL}>خبرها</a></li>
        </ul>
      </div>
    </label>
  )
}

export default Menu;
